import classnames from "classnames"
import moment from "moment"
import { withTranslate } from "../lng"

const Timeago = ({ date, className }) => {
  return (
    <span className={classnames("Timeago", className)}>
      {moment(date).fromNow()}
    </span>
  )
}

Timeago.displayName = "Timeago"

export default withTranslate(Timeago)
